import { CURRENCY } from './constants'

export const getters = {
  // eslint-disable-next-line no-unused-vars
  apiUrl: (state) => process.env.VUE_APP_API,
  isLoading(state) {
    return state.loading > 0;
  },
  logoutMinutes(state, rootGetters) {
    const user = rootGetters["account/userSetting"]("logoutMinutes") || 60;
    const org = state.logoutMinutes || 60;
    return Math.max(1, Math.min(user, org));
  },
  rightDrawer(state) {
    return state.rightDrawer;
  },
  breadcrumbs(state) {
    return state.breadcrumbs;
  },
  history(state) {
    return state.history;
  },
  itemsPerPage(state) {
    return state.itemsPerPage;
  },
  itemsPerPageOptions(state) {
    return state.itemsPerPageOptions;
  },
  currencyOptions(state, getters, rootState) {
    return rootState.metadata[CURRENCY] || [];
  },
  getCurrency: (state, getters) => (key) => {
    let opt = getters.currencyOptions.find((elem) => elem.value === key);
    return opt ? opt.text : key;
  },
  feature: (state) => (key) => {
    return state.features.find((f) => f.id === key);
  },
  assets(state) {
    return state.assets;
  },
  staticContent(state, getters, rootState, rootGetters) {
    const tenant = rootGetters["account/tenantId"] || "0";
    return `${process.env.VUE_APP_API}/${tenant}/v1/avtala/public`;
  },
  getTypeIcon: (state) => (type) => {
    return "$" + type;
  },
  getContactIcon: (state) => (contactType) => {
    return contactType === "person" ? "$person" : "$company";
  },
};
